module.exports = __webpack_public_path__ + "static/media/call-white.debef6fa.svg";